var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-with-fixed-bottom roadtrip-new with-botom-link"},[_c('LoadingIcon',{attrs:{"isLoading":_vm.isLoading}}),_c('ProductInformation',{attrs:{"roadtrip":_vm.roadtrip,"isLoading":_vm.isLoading},on:{"save":_vm.verifyForm}}),_c('MessageActionDialog',{on:{"yes":function($event){return _vm.confirmSave()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }